export default __webpack_public_path__ + "static/media/usuario_de_sistema.9b1e7240.svg";